/* eslint-disable no-extend-native */
Array.prototype.removeByValue = function () {
  var what, a = arguments, L = a.length, ax;
  while (L && this.length) {
    what = a[--L];
    while ((ax = this.indexOf(what)) !== -1) {
      this.splice(ax, 1);
    }
  }
  return this;
};

// Array usage 
// array.removeByValue(value)